import ReactDOM from 'react-dom/client';
import './index.scss';
import init from 'app/init';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const render = async () => {
  const vdom = await init();
  root.render(
    // <React.StrictMode>
    vdom
    // </React.StrictMode>
  );
};

render();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
